import React from 'react';
import { Card, CardHeader, CardBody, FormGroup, Label } from 'reactstrap';
import Select from 'react-select';

//Dropdown
import { DropdownCommon } from "@ui-partents/Dropdown";

// Define reusable options
const options = [
    { value: 'model1', label: 'Model 1' },
    { value: 'model2', label: 'Model 2' },
    { value: 'model3', label: 'Model 3' },
    { value: 'model4', label: 'Model 4' },
];

// Define size configurations
const dropdownSizes = [
    { label: 'Dropdown Input (36 px)', className: 'react-select-common' },
    { label: 'Dropdown Input (44 px)', className: 'react-select-common react-select-md' },
    { label: 'Dropdown Input (56 px)', className: 'react-select-common react-select-lg' },
];

const DropdownInput = () => {

    const menuData = [
        { to: '#', text: 'Home' },
        { to: '/about', text: 'About Us' },
        { to: '/services', text: 'Services' },
        { to: '/contact', text: 'Contact' },
        { to: '/faq', text: 'FAQ' }
    ];
    const handleDropdownItemClick = (item) => {
        console.log('Clicked item:', item);
        // Here you can add additional logic for when an item is clicked
    };
    return (
        <Card className="my-2">
            <CardHeader>Dropdown Input</CardHeader>
            <CardBody>
                {dropdownSizes.map((size, index) => (
                    <FormGroup key={index}>
                        <Label for={`modelSelect-${index}`}>{size.label}</Label>
                        <Select
                            id={`modelSelect-${index}`}
                            className={`${size.className} w-100`}
                            placeholder="Select item"
                            options={options}
                            classNamePrefix="react-select-custom"
                        />
                    </FormGroup>
                ))}

                <DropdownCommon
                    menuData={menuData}
                    textDropdown="Dropdown Toggle"
                    onItemClick={handleDropdownItemClick}
                />
            </CardBody>
        </Card>
    );
};

export default DropdownInput;